export default "__VITE_ASSET__B0DTSZ5L__"